import { Debt } from '../../interfaces';
import { getAllOpenHouseholdDebtsByAccountTypes } from './getAllOpenHouseholdDebtsByAccountTypes';

export const OTHER_DEBTS_ACCOUNT_TYPES = ['CU', 'HE', 'IS', 'LE', 'NT', 'RA', 'RD', 'SC', 'SE', 'UC'];

export const getAllHouseholdOtherDebts = (borrowerDebts: Debt[] = [], spouseDebts: Debt[] = []): Debt[] =>
  getAllOpenHouseholdDebtsByAccountTypes(borrowerDebts, spouseDebts, OTHER_DEBTS_ACCOUNT_TYPES);
